import React from 'react'

import Navigation from '../Navigation/Navigation';

const Catering = () => {
  return (
    <section id="catering">
      <Navigation></Navigation>
      <div className="content is-center">
        <h1 className="coming-soon">Cooming Soon...</h1>
        <p>Catering</p>
      </div>
    </section>
  )
}

export default Catering
